'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useQueryState } from 'nuqs';
import { toast } from 'sonner';
import type { GlobalFilter, GlobalFilterItem } from '../types';
import { useGlobalFilter } from './use-global-filter';

/**
 * Persists a set of filter items as the new global filter and refetches
 * everything. Shared between the legacy GlobalFilterModal and the
 * global-search-v2 filter page.
 */
export function useApplyGlobalFilter() {
  const queryClient = useQueryClient();
  const { setGlobalFilter } = useGlobalFilter();
  const [filter, setFilter] = useQueryState('filter');

  return (filterItems: GlobalFilterItem[]) => {
    const newFilters: GlobalFilter[string] = {
      global_realestates: [],
      global_segments: [],
      filter_external_clients: [],
      global_companies: [],
    };
    for (const item of filterItems) {
      newFilters[item.type].push(item.id);
    }
    setGlobalFilter(newFilters);
    if (filter) {
      setFilter(null);
    }
    queryClient.invalidateQueries();
    toast.info('Filtreringen uppdaterades', {
      description: 'Hämtar om listor...',
    });
  };
}
